import React from "react";
import "./styles.css";
import Movie from "./movieapi";

const Movieapp = () => {
  const [filterData, setfilterData] = React.useState("");
  return (
    <>
      <header>
        <h1> Marvel Phase-Wise Movies</h1>
      </header>
      <div className="input">
        <input
          type="text"
          placeholder="Search Name or phase"
          onChange={(e) => setfilterData(e.target.value)}
        />
      </div>
      {Movie.filter((val)=>{
        if(filterData==="")
        {
          return val;
        }
        else if(val.name.toLowerCase().includes(filterData.toLowerCase()) || val.category.toLowerCase().includes(filterData.toLowerCase()))
        {
          return val;
        }
      }).map((e) => {
        
        return (
          <>
          <section className="main-card--cointainer">
            <div className="card-container" key={e.id}>
              <div className="card">
                <div className="card-body">
                  <span className="card-number card-circle subtle" key={e.id}>
                    {e.id}
                  </span>
                  <span className="card-author subtle" key={e.category}>{e.category}</span>
                  <h2 className="card-title"key={e.name}>{e.name}</h2>
                  <h3 key={e.date}>{e.date}</h3>
                  <span className="card-description subtle">
                    <div className="card-read" key={e.description}>Read</div>
                    {e.description}
                  </span>
                </div>
                {/* <img src={e.image} alt="images" className="card-media" /> */}
                {/* <span className="card-tag subtle">Order Now</span> */}
              </div>
            </div>
            </section>
          </>
        );
      })}
    </>
  );
};

export default Movieapp;
